@let userInfo = userInfo$ | async;

@if (userInfo !== null) {
  @if (userInfo.displayName) {
    <div class="user-container">
      <glxy-avatar
        class="user-avatar"
        [name]="userInfo.displayName"
        [width]="AVATAR_WIDTH"
        [src]="userInfo.profileImageUrl"
      ></glxy-avatar>
      <span>{{ userInfo.displayName }}</span>
    </div>
  } @else {
    <glxy-blank-value></glxy-blank-value>
  }
} @else {
  <div class="stencil-shimmer"></div>
}
